const common = {
    no_data: '暫無資料',
    header: {
        business_name: '您的業務'
    },
    download_app: {
        text: '要使用 Simply 網頁版，請使用手提電腦或個人電腦。',
        button: '下載手機版'
    },
    unknown: '未知',
    request_error: '發生錯誤。請再試一次！或聯絡客戶支援報告您的問題。',
    home: '主頁',
    dashboard: '儀表板',
    product: '產品',
    add_product: '新增產品',
    edit_product: '編輯產品',
    stock_in: '入貨',
    Sales_Turnover: '銷售額',
    profit: '利潤',
    stock_out: '出貨',
    staff: '員工',
    stock_audit: '庫存盤點',
    button: {
        save: '儲存',
        save_and_add_more: '儲存並繼續新增',
        submit: '提交',
        done: '完成',
        edit: '編輯',
        save_edit: '儲存更改',
        yes: '是',
        clear: '清除',
        delete: '刪除',
        cancel: '取消',
        reset: '重設'
    },
    select_date: '選擇日期',
    select_action: '選擇動作',
    mandatory: ' *(必填)',
    not_mandatory: '(非必填)',
    business: '業務',
    account: '帳戶',
    profile: '個人資料',
    setting: '設定',
    whichLanguage: '中文(繁體, 香港)',
    headerDashboard: '成為 VIP',
    contact_us: '聯絡我們',
    logout: '登出',
    category: '類別',
    add_category: '新增類別',
    data: '資料',
    history: '記錄',
    lowStockAlert: '低存貨提示',
    Expenses: '開支',
    lowStockAlertButton: '新增安全存量',
    message: {
        login_success: '登入成功！',
        onboard_success: '恭喜！！您的旅程開始啦！',
        successfully_saved: '資料儲存成功',
        successfully_deleted: '資料刪除成功',
        error_required_field: '必填欄位不能留空',
        no_access: '無權限存取',
        no_permission: '您沒有權限',
        error_update_history: '更新記錄失敗'
    },
    no_permission_dialog: {
        title: '沒有權限',
        description: '您沒有權限查看開支。請聯絡您的管理員。'
    },
    feedback: '意見反饋',
    contact: '聯絡',
    add: '新增',
    supplier: '供應商',
    customer: '客戶',
    random: '隨機',
    scan: '掃描',
    enter: '掃描條碼登入',
    terms: {
        text: '繼續即表示您同意',
        link: '私隱政策'
    },
    others: '其他',
    calender: {
        presets: {
            today: '今日',
            yesterday: '昨日',
            last_7_days: '過去 7 天',
            last_30_days: '過去 30 天',
            this_month: '本月',
            last_month: '上月',
            custom_range: '自訂範圍'
        }
    },
    print_large: '列印大型 (A4)',
    print_letter: '列印信紙 (US)',
    print_dot_matrix: '列印大型 (點陣)',
    print_medium: '列印中型 (75mm)',
    print_small: '列印小型 (48mm)',
    format: '紙張格式',
    preview: '預覽',
    view_invoice: '發票',
    view_chalan: '提貨單',
    price: '價格',
    stock: '存貨',
    quantity: '數量',
    total: '總額',
    print_footer_left: '由',
    print_footer_center: '列印於',
    print_footer_date: '於',
    print_to: '致',
    language: '中文(繁體, 香港)',
    dateStatus: '過去 7 天',
    placeholder: '交易類型',
    staffHistory: '選擇員工',
    languageTitle: '中文(繁體, 香港)',
    date: '日期',
    download: '下載',
    download_excel: '下載 Excel',
    download_pdf: '下載條碼',
    currentTitle: '貨幣',
    Selectperiod: '選擇期間',
    TransactionType: '交易類型',
    SelectCustomer: '選擇客戶',
    invoice: '發票',
    login: {
        google: '使用 Google 登入',
        apple: '使用 Apple 登入'
    },
    trusted_by: {
        title: '超過 50,000 間印尼業務信賴 🇮🇩'
    },
    privacyPolicyOne: "登入即表示您同意 Simply 的",
    privacyPolicyTwo: '私隱政策',
    manufacture: '製造',
    warehouse: '倉庫',
    error: {
        title: '哎呀！出了點問題',
        description: '發生了一個意外錯誤。請嘗試重新載入頁面或返回首頁。',
        refresh: '重新載入頁面',
        go_back: '返回首頁',
        not_found: '找不到頁面'
    },
    totalPurchasePrice: '總採購價格',
    pageTotalPurchaseAmount: '本頁總採購金額',
    approval_status: '審批狀態',
    pending: '待處理',
    approved: '已批准',
    rejected: '已拒絕',
    select_fields: '選擇欄位',
    syncWithTally: '與 Tally 同步',
    importFromTally: '從 Tally 匯入',
    exportToTally: '匯出至 Tally',
    All: '全部',
    Approval: '審批'
}
export default common